import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Box,
  IconButton,
  Modal,
  Stack,
  Typography,
} from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useNavigate } from 'react-router-dom';

function MeetingDisclaimer() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);

  return (
    <Modal open={open} disableEscapeKeyDown>
      <Box
        sx={{
          borderRadius: '12px',
          background: '#FFFFFF',
          maxWidth: '480px',
          width: '90%',
          padding: '28px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <Stack gap={4}>
          <Stack gap={2}>
            <Stack direction='row' justifyContent='space-between'>
              <Stack justifyContent='center'>
                <Typography fontSize={18} fontWeight={500}>
                  <FormattedMessage defaultMessage='Consent for recording' />
                </Typography>
              </Stack>
              <Stack>
                <IconButton
                  onClick={() => {
                    navigate('/inbox');
                  }}
                >
                  <CloseIcon />
                </IconButton>
              </Stack>
            </Stack>
            <Stack>
              <Typography
                sx={{
                  color: (theme) => theme.palette.neutralWhiteBg[500],
                }}
              >
                <FormattedMessage
                  defaultMessage="Before we begin, your privacy matters to us. To ensure transparency and comply with privacy laws, we kindly ask for your consent to record this call. Rest assured, this recording is strictly for internal purposes and will be handled with the utmost confidentiality. {linebreak} {linebreak} By clicking <span> 'I Consent' </span> you agree to the recording of this call."
                  values={{
                    linebreak: <br />,
                    span: (chunks) => {
                      return (
                        <Typography sx={{ color: '#181818' }} component='span'>
                          {chunks}
                        </Typography>
                      );
                    },
                  }}
                ></FormattedMessage>
              </Typography>
            </Stack>
          </Stack>
          <Stack direction='row' justifyContent='center'>
            <Stack flexGrow={1}>
              <Button
                sx={{
                  textTransform: 'none',
                  display: 'flex',
                  width: '100%',
                  padding: '8px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: '50px',
                  background: (theme) =>
                    `linear-gradient(294deg, ${theme.palette.teal.main} 16.77%, ${theme.palette.green[500]} 53.83%)`,
                  color: '#181818',
                }}
                onClick={() => {
                  setOpen(false);
                }}
              >
                <FormattedMessage defaultMessage='I Consent' />
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Box>
    </Modal>
  );
}

export default MeetingDisclaimer;
